export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '流程类型',
            prop: 'mipType',
            type: 'select',
            optionsKey: 'MIP_TYPE',
            minWidth: 90
        },
        {
            label: '关联退出报告流程',
            prop: 'contractCode',
            minWidth: 160
        },
        {
            label: '审批状态',
            prop: 'mipStatus',
            type: 'select',
            optionsKey: 'RENEWAL_AUDIT_STATUS',
            minWidth: 80
        },
        {
            label: '审批通过时间',
            prop: 'processCompleteDate',
            minWidth: 160
        },
        {
            label: 'mip审批流编码',
            prop: 'mipId',
            minWidth: 160
        },
        {
            label: '创建人',
            prop: 'createUserCode',
            minWidth: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 160
        },
        {
            label: '修改人',
            prop: 'updateUserCode',
            minWidth: 100
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 160
        },
        {
            label: '审批流',
            prop: 'mipUrl',
            showTooltip: true,
            type: 'slot',
            minWidth: 300
        }
    ]
};
